import { Language } from '../../../model/misc.model';
import { SiteContextActions } from '../actions/index';
import { LanguagesActionTypes } from '../actions/languages.action';
import { LanguagesState } from '../site-context-state';

export const initialState: LanguagesState = {
  entities: null,
  activeLanguage: null,
};

export function reducer(state = initialState, action: SiteContextActions.LanguagesActions): LanguagesState {
  switch (action.type) {
    case LanguagesActionTypes.LoadLanguagesSuccess: {
      const languages: Language[] = action.payload;
      const entities = languages.reduce(
        (langEntities: { [isocode: string]: Language }, language: Language) => {
          return {
            ...langEntities,
            [language.isocode]: language,
          };
        },
        {
          ...state.entities,
        }
      );

      return {
        ...state,
        entities,
      };
    }

    case LanguagesActionTypes.SetActiveLanguage: {
      const isocode = action.payload;

      return {
        ...state,
        activeLanguage: isocode,
      };
    }
  }
  return state;
}
